"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[16035],{

/***/ 848884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ HomepageFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HomepageFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.512 1.43055C11.7928 1.18982 12.2073 1.18982 12.4881 1.43055L21.4881 9.14455C21.7264 9.3488 21.8123 9.67984 21.7035 9.9742C21.5946 10.2686 21.3139 10.464 21 10.464H20.75V19.18C20.75 20.1852 19.9665 21 19 21H15V16.1776C15 15.6001 14.7542 15.0462 14.3166 14.6378C13.879 14.2294 13.2856 14 12.6667 14H11.3333C10.7144 14 10.121 14.2294 9.6834 14.6378C9.24583 15.0462 9 15.6001 9 16.1776V21H5C4.0335 21 3.25 20.1852 3.25 19.18V10.464H3.00004C2.68618 10.464 2.40551 10.2686 2.29662 9.9742C2.18773 9.67984 2.27365 9.3488 2.51195 9.14455L11.512 1.43055Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 316035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ ProductDetailProvider; },
  "W": function() { return /* binding */ useProductDetailState; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/helpers.es.js
var helpers_es = __webpack_require__(77829);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Currency/Currency.es.js
var Currency_es = __webpack_require__(853675);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/HomepageFilled.es.js
var HomepageFilled_es = __webpack_require__(848884);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../packages/payment/dist/types.es.js
var types_es = __webpack_require__(710957);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./helpers/confirm18YearsOld.ts
var confirm18YearsOld = __webpack_require__(41796);
// EXTERNAL MODULE: ./helpers/products.ts
var products = __webpack_require__(646130);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(927890);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ./contexts/ToastContext.tsx
var ToastContext = __webpack_require__(508285);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
;// CONCATENATED MODULE: ./hooks/useCalculatePrice.ts
/* eslint-disable react-hooks/exhaustive-deps */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const useCalculatePrice = (sku, defaultValue, productAvailable, selectPromotionId, isReturnVariants)=>{
    const { cartServiceV2  } = (0,ServiceContext/* useServices */.Su)();
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const toast = (0,ToastContext/* useToast */.p)(isMobile);
    const { 0: payloadAddToCart , 1: setPayloadAddToCart  } = (0,react.useState)({
        sku,
        quantity: 1,
        isPrimary: undefined
    });
    const { 0: calculatePrice , 1: setCalculatePrice  } = (0,react.useState)(defaultValue);
    const { 0: isLoading , 1: setLoading  } = (0,react.useState)(false);
    const { quantity  } = payloadAddToCart;
    // hotfix for missing token when get price and promotion
    const { user  } = (0,context_es/* useAuth */.aC)();
    const { data: dataCalculatePrice , isValidating  } = (0,index_esm/* default */.ZP)(productAvailable ? [
        "cart_service/get_price",
        sku,
        quantity,
        selectPromotionId,
        user === null || user === void 0 ? void 0 : user.id,
        isReturnVariants, 
    ] : null, async (_, sku, quantity)=>{
        return cartServiceV2.getPriceAndPromotion(sku, _objectSpreadProps(_objectSpread({
            quantity
        }, !!selectPromotionId && !Number.isNaN(Number(selectPromotionId)) ? {
            selectedPromotionId: Number(selectPromotionId)
        } : {}), {
            isReturnVariants
        }));
    }, {
        revalidateOnFocus: false,
        fallback: _objectSpread({}, defaultValue)
    });
    const selectedPromotion = (0,react.useMemo)(()=>{
        try {
            const promotions = calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.promotions.map((p)=>p.promotions).reduce((a, b)=>[
                    ...a,
                    ...b
                ], []);
            return promotions === null || promotions === void 0 ? void 0 : promotions.find((p)=>p.isSelectable && p.isSelected);
        } catch (e) {
            return null;
        }
    }, [
        JSON.stringify(calculatePrice)
    ]);
    (0,react.useEffect)(()=>{
        if (!productAvailable) {
            setCalculatePrice(defaultValue);
        }
        if (!!dataCalculatePrice && !isValidating) {
            setCalculatePrice(dataCalculatePrice);
        }
    }, [
        JSON.stringify(dataCalculatePrice),
        isValidating,
        productAvailable,
        JSON.stringify(defaultValue), 
    ]);
    const selectPromotion = async (promotion)=>{
        try {
            setLoading(true);
            const newCalculate = await cartServiceV2.calculatePrice({
                sku: payloadAddToCart.sku,
                selectPromotionId: promotion === null || promotion === void 0 ? void 0 : promotion.promotionId,
                quantity: payloadAddToCart.quantity
            });
            setCalculatePrice(newCalculate);
            if (promotion === undefined) {
                var ref;
                (ref = toast.success) === null || ref === void 0 ? void 0 : ref.call(toast, {
                    title: "",
                    message: "",
                    [isMobile ? "message" : "title"]: (0,i18n.t)("Bỏ \xe1p dụng khuyến m\xe3i th\xe0nh c\xf4ng")
                });
            } else {
                var ref1;
                (ref1 = toast.success) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                    title: "",
                    message: "",
                    [isMobile ? "message" : "title"]: (0,i18n.t)("\xc1p dụng khuyến m\xe3i th\xe0nh c\xf4ng")
                });
            }
        } catch (err) {
            var ref2;
            index_es/* logger.error */.k.error(err);
            (ref2 = toast.error) === null || ref2 === void 0 ? void 0 : ref2.call(toast, {
                title: "",
                message: "",
                [isMobile ? "message" : "title"]: (0,i18n.t)("C\xf3 lỗi xảy ra")
            });
        } finally{
            setLoading(false);
        }
    };
    return {
        price: _objectSpread({
            finalPrice: calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.price
        }, calculatePrice),
        promotionBlocks: (calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.promotions) || [],
        setPayloadAddToCart,
        selectPromotion,
        payloadAddToCart,
        promotionLoading: isValidating,
        priceLoading: isValidating,
        selectPromotionLoading: isLoading,
        selectedPromotion,
        applicableInstallmentMethods: calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.applicableInstallmentMethods,
        variants: calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.variants
    };
};

// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-2.3.6-0bc101c0e7-4b2bbf6bc6.zip/node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(391547);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
// EXTERNAL MODULE: ./services/clients/api.ts
var api = __webpack_require__(44844);
;// CONCATENATED MODULE: ./services/public-service.ts
function public_service_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function public_service_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            public_service_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


api/* publicSettingApi.addInterceptor */.Wk.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
const publicService = {
    // api docs: https://apidoc.teko.vn/project-doc/approved/omni_retail/presentation_layer/public_bff/version/15d54366/paths/api-v1-get-location-options/get
    getLocationOptions: async (domain)=>{
        var ref;
        const data = await api/* publicSettingApi.get */.Wk.get("/get-location-options", {
            params: {
                domain
            }
        });
        return (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.data) || [];
    },
    // api docs: https://apidoc.teko.vn/project-doc/approved/omni_retail/presentation_layer/public_bff/version/latest/operations/sale-policies
    getSalePoliciesBySku: (params, language)=>{
        return api/* publicSettingApi.get */.Wk.get("/sale-policies", {
            params: public_service_objectSpread({}, params),
            headers: {
                "Accept-Language": language || "*"
            }
        }).then((param)=>{
            let { data  } = param;
            return Promise.resolve(data);
        });
    }
};

;// CONCATENATED MODULE: ./hooks/usePolicies.tsx
function usePolicies_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function usePolicies_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            usePolicies_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function usePolicies_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function usePolicies_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        usePolicies_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const OTHER_POLICIES = 0;
const convertPolicies = (policies)=>{
    return policies.map((el, index)=>({
            id: index,
            content: el.displayText,
            icon: el.iconUrl,
            detailUrl: el.detailUrl
        }));
};
const usePolicies = (sku, sellerId)=>{
    const { terminalId , currentLanguage , terminal , useTerminalId , epicOmni1643  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { loading , user  } = (0,context_es/* useAuth */.aC)();
    const { data: allPolicies = []  } = (0,index_esm/* default */.ZP)(!!sku && !loading ? [
        "/sale-policies",
        sku,
        sellerId,
        user === null || user === void 0 ? void 0 : user.id
    ] : null, async ()=>{
        const { policies  } = await publicService.getSalePoliciesBySku(usePolicies_objectSpreadProps(usePolicies_objectSpread({
            sku
        }, flags.epic_omni_1237 ? {
            sellerId
        } : {}, flags.epic_ecom_284 || useTerminalId ? {
            terminalId
        } : {
            terminalCode: terminal
        }), {
            isHighlightedOnPromotionBlock: epicOmni1643
        }), currentLanguage);
        return policies.map((policy)=>usePolicies_objectSpreadProps(usePolicies_objectSpread({}, policy), {
                // after remove 305 --> displayText is required param
                displayText: purify_default().sanitize(policy.displayText || "")
            }));
    }, {
        revalidateOnFocus: false
    });
    const salePolicies = allPolicies.filter((policy)=>policy.serviceGroupId !== OTHER_POLICIES && (!!policy.isHighlightedOnProductDetail || !epicOmni1643));
    const otherPolicies = allPolicies.filter((policy)=>policy.serviceGroupId === OTHER_POLICIES && (!!policy.isHighlightedOnProductDetail || !epicOmni1643));
    const paymentPromotionPolicies = allPolicies.filter((policy)=>!!policy.isHighlightedOnPromotionBlock);
    return {
        policies: convertPolicies(allPolicies),
        salePolicies: convertPolicies(salePolicies),
        otherPolicies: convertPolicies(otherPolicies),
        paymentPromotionPolicies: convertPolicies(paymentPromotionPolicies)
    };
};

// EXTERNAL MODULE: ./hooks/useDiscovery.tsx + 1 modules
var useDiscovery = __webpack_require__(88837);
// EXTERNAL MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts + 2 modules
var useHandlerUnderEighteenYearOld = __webpack_require__(725530);
// EXTERNAL MODULE: ./services/consumer.ts
var consumer = __webpack_require__(667913);
;// CONCATENATED MODULE: ./hooks/useProductRating.ts
function useProductRating_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useProductRating_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useProductRating_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useProductRating_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useProductRating_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useProductRating_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const DEFAULT_GET_REVIEWS_PAGE_SIZE = 5;
const useProductRatingList = (product)=>{
    var ref, ref1;
    const { platformId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: filterParams , 1: setFilterParams  } = (0,react.useState)();
    const { 0: page , 1: setPage  } = (0,react.useState)(1);
    const { 0: reviews , 1: setReviews  } = (0,react.useState)([]);
    const getKey = ()=>{
        var ref, ref1;
        // have no productId -> stop fetching
        if (!(product === null || product === void 0 ? void 0 : (ref = product.productGroup) === null || ref === void 0 ? void 0 : ref.id)) return null;
        return [
            "/product-reviews/".concat(product === null || product === void 0 ? void 0 : (ref1 = product.productGroup) === null || ref1 === void 0 ? void 0 : ref1.id),
            page,
            filterParams === null || filterParams === void 0 ? void 0 : filterParams.rating,
            filterParams === null || filterParams === void 0 ? void 0 : filterParams.hasImage,
            filterParams === null || filterParams === void 0 ? void 0 : filterParams.hasVideo, 
        ];
    };
    const { data , isValidating , mutate: refreshReviewList ,  } = (0,index_esm/* default */.ZP)(getKey, async ()=>{
        try {
            var ref;
            if (!(product === null || product === void 0 ? void 0 : (ref = product.productGroup) === null || ref === void 0 ? void 0 : ref.id)) return undefined;
            const res = await (0,consumer/* getProductReviews */.mk)(product.productGroup.id, useProductRating_objectSpreadProps(useProductRating_objectSpread({}, filterParams), {
                page,
                pageSize: DEFAULT_GET_REVIEWS_PAGE_SIZE,
                platformId
            }));
            return res;
        } catch (error) {
            index_es/* logger.error */.k.error("Error occur when getProductReviews: ".concat(error));
            return undefined;
        }
    }, {
        onSuccess: (data)=>{
            var ref;
            const newReviews = (data === null || data === void 0 ? void 0 : (ref = data.pagination) === null || ref === void 0 ? void 0 : ref.page) === 1 ? data.reviews : [
                ...reviews,
                ...(data === null || data === void 0 ? void 0 : data.reviews) || []
            ];
            setReviews(newReviews);
        },
        revalidateOnFocus: false
    });
    const { ratingCounts , averageRating , totalReviews  } = data || {};
    return {
        data,
        reviews,
        ratingCounts,
        averageRating,
        totalReviews,
        filterParams,
        setFilterParams,
        loadMore: ()=>setPage((prev)=>prev + 1),
        hasMore: reviews.length < ((data === null || data === void 0 ? void 0 : (ref = data.pagination) === null || ref === void 0 ? void 0 : ref.total) || 0),
        noFilter: !filterParams || Object.values(filterParams).every((val)=>!val),
        numberOfReviewsRemaining: ((data === null || data === void 0 ? void 0 : (ref1 = data.pagination) === null || ref1 === void 0 ? void 0 : ref1.total) || 0) - reviews.length,
        setPage,
        isValidating,
        refreshReviewList
    };
};

;// CONCATENATED MODULE: ./hooks/useDetailPage.tsx
function useDetailPage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDetailPage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDetailPage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useDetailPage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useDetailPage_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useDetailPage_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















const useDetailPage = (serverProduct)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    const { epicOmni976 , isMobile , epicOmni1459 , merchantInstallmentMethodCode , epicEcom495 , passSkuToReturnSimilarProducts , displayNewLayoutForProductDetailSGC ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { paymentBffService  } = (0,ServiceContext/* useServices */.Su)();
    const { 0: sku , 1: setSku  } = (0,react.useState)(serverProduct === null || serverProduct === void 0 ? void 0 : (ref = serverProduct.product) === null || ref === void 0 ? void 0 : (ref1 = ref.productInfo) === null || ref1 === void 0 ? void 0 : ref1.sku);
    const { 0: showPopupCheckAge , 1: setShowModalCheckAge  } = (0,react.useState)();
    const { 0: isUserUnder18 , 1: setIsUserUnder18  } = (0,react.useState)();
    const { 0: showWarningPromotionWithInstallment , 1: setShowWarningPromotionWithInstallment  } = (0,react.useState)(false);
    const { 0: minAmountByMonth , 1: setMinAmountByMonth  } = (0,react.useState)();
    const { 0: isReturnVariants , 1: setIsReturnVariants  } = (0,react.useState)(false);
    const { 0: loadingProductDetailPage , 1: setLoadingProductDetailPage  } = (0,react.useState)(false);
    const { convertProduct  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)({
        handleUnder18: ()=>setShowModalCheckAge(true)
    });
    const { loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const setShowPopupCheckAge = (value)=>{
        setShowModalCheckAge(value);
        if (!value) {
            setIsUserUnder18(false);
            (0,confirm18YearsOld/* markUserIsOver18 */.P1)();
        }
    };
    const router = (0,next_router.useRouter)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const { result , mutate: mutateProduct , isLoading ,  } = (0,useDiscovery/* useDiscoveryProduct */.uD)(sku || router.query.sku, router.query.productId, {
        revalidateIfStale: true,
        fallbackData: serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.product
    });
    (0,react.useEffect)(()=>{
        // use useEffect instead of swr onSuccess
        // since the later does not get called consistently
        if (!isLoading && (result === null || result === void 0 ? void 0 : result.product) && router.query.sku != sku) {
            const { sku: newSku , canonical  } = result.product.productInfo;
            const queryParams = (0,dist_index_es.cleanObject)({
                sku: newSku,
                productId: router.query.productId
            });
            router.replace({
                pathname: !router.query.productId ? "/products/[sku]" : "/products/detail/[productId]",
                query: queryParams
            }, {
                pathname: "/".concat(canonical),
                query: (0,products/* isVariantUrlGrouped */.X)(canonical) ? {
                    sku: newSku
                } : {}
            }, {
                //In new detailPage SGC new layout, when replace router with new sku, always rerender the page.
                shallow: !displayNewLayoutForProductDetailSGC
            });
        }
    }, [
        isLoading,
        result === null || result === void 0 ? void 0 : (ref2 = result.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.productInfo) === null || ref3 === void 0 ? void 0 : ref3.sku,
        displayNewLayoutForProductDetailSGC, 
    ]);
    const { flattenItems  } = (0,CartContextV2/* useCartV2 */.T6)();
    // state to check if a product variant is being fetched
    // to be replaced with a global loader
    const product = (0,react.useMemo)(()=>(0,discovery/* convertProductDetail */.NP)(result.product), [
        result.product
    ]);
    const defaultPrice = !(0,helpers/* isServerless */.ep)() ? serverProduct.priceAndPromotions : convertDiscoveryPrice(product.price, ((ref4 = product.status) === null || ref4 === void 0 ? void 0 : ref4.sellable) ? serverProduct === null || serverProduct === void 0 ? void 0 : (ref5 = serverProduct.priceAndPromotions) === null || ref5 === void 0 ? void 0 : ref5.promotions : []);
    /**
   * product from server is product in HCM City
   * if user is in other city, we need revalidate price and promotions
   */ const { price , promotionBlocks , setPayloadAddToCart , selectPromotion , payloadAddToCart , promotionLoading , priceLoading , selectedPromotion , selectPromotionLoading , applicableInstallmentMethods , variants ,  } = useCalculatePrice(sku, defaultPrice, product === null || product === void 0 ? void 0 : (ref6 = product.status) === null || ref6 === void 0 ? void 0 : ref6.sellable, router.query.selectPromotionId || (0,helpers_es/* getParamsFromUrl */.FW)(router.asPath, "selectPromotionId") || "", isReturnVariants);
    const { policies , salePolicies , otherPolicies , paymentPromotionPolicies  } = usePolicies(sku, (ref7 = product.seller) === null || ref7 === void 0 ? void 0 : ref7.id);
    const searchRelatedProductsParams = passSkuToReturnSimilarProducts ? {
        page: 1,
        pageSize: search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
        filter: {
            skuToReturnSimilarProducts: sku
        }
    } : !!(product === null || product === void 0 ? void 0 : product.categories.length) ? {
        page: 1,
        pageSize: search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
        filter: {
            excludedSkus: [
                product === null || product === void 0 ? void 0 : product.sku
            ],
            categoryIds: [
                product === null || product === void 0 ? void 0 : product.categories[(product === null || product === void 0 ? void 0 : product.categories.length) - 1].id
            ]
        }
    } : {};
    const { result: searchRelatedProductsResult  } = (0,useDiscovery/* useSearch */.Rx)(searchRelatedProductsParams);
    // fallback to serverProduct if not found
    const relatedProducts = ((ref8 = (searchRelatedProductsResult === null || searchRelatedProductsResult === void 0 ? void 0 : searchRelatedProductsResult.products) || []) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 ? searchRelatedProductsResult === null || searchRelatedProductsResult === void 0 ? void 0 : searchRelatedProductsResult.products : serverProduct.relatedProducts;
    // EPIC-315: effect replace images when user is under 18 years old
    const { images , actionReady  } = (0,react.useMemo)(()=>{
        return convertProduct(product);
    }, [
        product === null || product === void 0 ? void 0 : product.categories,
        isUserUnder18,
        authLoading
    ]);
    const productRatingData = useProductRatingList(useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, product), {
        images
    }));
    // backward compatibility for epic_ecom_315
    (0,react.useEffect)(()=>{
        if (flags.epic_ecom_315) return;
        if ((0,confirm18YearsOld/* needConfirm18YearsOld */.av)((product === null || product === void 0 ? void 0 : product.isAlcoholicCategory) || false)) {
            setShowPopupCheckAge(true);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.sku,
        product === null || product === void 0 ? void 0 : product.isAlcoholicCategory
    ]);
    const stockAvailable = (product === null || product === void 0 ? void 0 : product.needManageStock) ? (product === null || product === void 0 ? void 0 : product.totalAvailable) || 0 : 999;
    const onSelectVariant = async (variant)=>{
        // if other sku
        const newSku = variant.sku;
        if (newSku === router.query.sku && variant.quantity === payloadAddToCart.quantity) return;
        setPayloadAddToCart((prev)=>{
            return useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, prev), {
                // note: this logic is little confusing.
                // for variants that have no overlapping attributes with current sku
                // Discovery productOptions is returning 0 quantity
                // client would display this variant as a blurred option.
                quantity: variant.quantity === 0 ? 1 : variant.quantity,
                sku: variant.sku
            });
        });
        if (newSku === router.query.sku) {
            var ref;
            await mutateProduct(useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, result.product), {
                productOptions: useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, product.productOptions), {
                    rows: (ref = product.productOptions) === null || ref === void 0 ? void 0 : ref.rows.map((row)=>useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, row), {
                            options: row.options.map((col)=>col.quantity === variant.quantity ? useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, col), {
                                    selected: true
                                }) : useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, col), {
                                    selected: false
                                }))
                        }))
                })
            }), {
                revalidate: false
            });
        } else {
            setSku(newSku);
        }
    };
    const isCanAddToCard = product && (product.isBundle || passQuantityCheck(product === null || product === void 0 ? void 0 : product.needManageStock, stockAvailable, (ref9 = (flattenItems || []).find((item)=>item.sku === product.sku)) === null || ref9 === void 0 ? void 0 : ref9.quantity));
    const isOutOfStock = (product === null || product === void 0 ? void 0 : product.totalAvailable) !== null && product.totalAvailable !== undefined && (product === null || product === void 0 ? void 0 : product.totalAvailable) <= 0;
    const showFlashSale = (0,react.useMemo)(()=>{
        if (!product) return false;
        if (!product.flashSale) return false;
        const { total , used  } = product.flashSale;
        const remain = Math.min(total - used, stockAvailable);
        return remain > 0;
    }, [
        product,
        stockAvailable
    ]);
    const breadcrumbs = (0,react.useMemo)(()=>{
        var ref;
        if (epicEcom495) {
            var ref1;
            const homeBreadcrumb = [
                {
                    link: "/",
                    name: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageFilled_es/* HomepageFilled */.f, {
                        size: 16,
                        color: "placeholder",
                        style: {
                            marginRight: "4px"
                        }
                    }),
                    isLast: true
                },
                {
                    link: "/",
                    name: (0,i18n.t)("Trang chủ")
                }, 
            ];
            const productName = (product === null || product === void 0 ? void 0 : product.displayName) || (product === null || product === void 0 ? void 0 : product.name) || "";
            const breadcrumbs = (product === null || product === void 0 ? void 0 : (ref1 = product.breadcrumbs) === null || ref1 === void 0 ? void 0 : ref1.length) ? [
                ...homeBreadcrumb,
                ...product.breadcrumbs
            ] : [
                ...homeBreadcrumb
            ];
            return [
                ...breadcrumbs,
                {
                    disabled: true,
                    link: "#",
                    name: productName
                }, 
            ];
        }
        if (!(serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.breadcrumbs) || (serverProduct === null || serverProduct === void 0 ? void 0 : (ref = serverProduct.breadcrumbs) === null || ref === void 0 ? void 0 : ref.length) === 0 || !epicOmni976) {
            return isMobile || epicOmni976 ? [] : [
                {
                    link: "/",
                    name: (0,i18n.t)("Trang chủ")
                },
                {
                    disabled: true,
                    link: "#",
                    name: (product === null || product === void 0 ? void 0 : product.displayName) || (product === null || product === void 0 ? void 0 : product.name) || ""
                }, 
            ];
        }
        return [
            {
                link: "/",
                name: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageFilled_es/* HomepageFilled */.f, {
                    size: 24,
                    color: "placeholder"
                })
            },
            ...serverProduct.breadcrumbs, 
        ];
    }, [
        epicOmni976,
        isMobile,
        epicEcom495
    ]);
    const isAllowInstallmentPayment = (0,react.useMemo)(()=>{
        var ref, ref1;
        return !!epicOmni1459 && ((ref = serverProduct.priceAndPromotions) === null || ref === void 0 ? void 0 : (ref1 = ref.availableInstallmentPaymentMethods) === null || ref1 === void 0 ? void 0 : ref1.includes(types_es/* PaymentMethodCode.VNPAY_INSTALLMENT_CREDIT */.K$.VNPAY_INSTALLMENT_CREDIT));
    }, [
        (ref10 = serverProduct.priceAndPromotions) === null || ref10 === void 0 ? void 0 : ref10.availableInstallmentPaymentMethods,
        epicOmni1459, 
    ]);
    const selectedPromotionsNotApplyWithInstallment = (0,react.useMemo)(()=>{
        return promotionBlocks.flatMap((promotionGroup)=>promotionGroup.promotions).filter((promotion)=>{
            var ref;
            return promotion.isSelected && !!((ref = promotion.highlightedDescriptions) === null || ref === void 0 ? void 0 : ref.length);
        });
    }, [
        promotionBlocks
    ]);
    const getMinAmountByMonth = (terms)=>{
        const periods = terms.flatMap((t)=>t.paymentMethods.flatMap((paymentMethod)=>paymentMethod.periods));
        let minAmount;
        if (periods.length) {
            minAmount = periods[0].amountByMonth;
            for(let i = 0; i < periods.length; i++){
                if (periods[i].amountByMonth < minAmount) {
                    minAmount = periods[i].amountByMonth;
                }
            }
        }
        return minAmount;
    };
    const vnpayInstallmentCreditMethod = (0,react.useMemo)(()=>{
        return !!(applicableInstallmentMethods === null || applicableInstallmentMethods === void 0 ? void 0 : applicableInstallmentMethods.length) ? applicableInstallmentMethods.find((method)=>method.methodCode === types_es/* PaymentMethodCode.VNPAY_INSTALLMENT_CREDIT */.K$.VNPAY_INSTALLMENT_CREDIT) : undefined;
    }, [
        applicableInstallmentMethods
    ]);
    (0,react.useEffect)(()=>{
        const getInstallmentTerms = async (merchantMethodCode, amount)=>{
            try {
                const { terms  } = await paymentBffService.getInstallmentTerms(merchantMethodCode, amount);
                const minAmount = getMinAmountByMonth(terms);
                setMinAmountByMonth(minAmount);
            } catch (error) {
                index_es/* logger.error */.k.error("getInstallmentTerms error", error);
                window.track("GetInstallmentTermsEvent", "getInstallmentTermsError", error);
            }
        };
        // not call API when not allow purchase in installment (isAllowInstallmentPayment = false)
        if (isAllowInstallmentPayment && merchantInstallmentMethodCode && typeof (vnpayInstallmentCreditMethod === null || vnpayInstallmentCreditMethod === void 0 ? void 0 : vnpayInstallmentCreditMethod.installmentPrice) === "number") {
            getInstallmentTerms(merchantInstallmentMethodCode, vnpayInstallmentCreditMethod.installmentPrice);
        }
    }, [
        vnpayInstallmentCreditMethod === null || vnpayInstallmentCreditMethod === void 0 ? void 0 : vnpayInstallmentCreditMethod.installmentPrice,
        paymentBffService,
        merchantInstallmentMethodCode,
        isAllowInstallmentPayment, 
    ]);
    return {
        isLoading,
        product: useDetailPage_objectSpreadProps(useDetailPage_objectSpread({}, product), {
            images
        }),
        primitiveProduct: (result === null || result === void 0 ? void 0 : result.product) || serverProduct.product,
        frame: (0,products/* getFrame */.$)((product === null || product === void 0 ? void 0 : product.tags) || [], frames),
        onSelectVariant,
        stockAvailable,
        isOutOfStock,
        relatedProducts,
        isCanAddToCard,
        showFlashSale,
        setSelectedPromotion: selectPromotion,
        selectPromotionLoading,
        price,
        setPayloadAddToCart,
        payloadAddToCart,
        promotionBlocks,
        promotionLoading,
        priceLoading,
        selectedPromotion,
        showPopupCheckAge,
        setShowPopupCheckAge,
        actionReady,
        breadcrumbs: breadcrumbs || [],
        isAllowInstallmentPayment,
        showWarningPromotionWithInstallment,
        setShowWarningPromotionWithInstallment,
        selectedPromotionsNotApplyWithInstallment,
        minAmountByMonth,
        variants,
        setIsReturnVariants,
        productRatingData,
        serverRating: serverProduct.rating,
        policies,
        salePolicies,
        otherPolicies,
        paymentPromotionPolicies,
        loadingProductDetailPage,
        setLoadingProductDetailPage
    };
};
const passQuantityCheck = (needManageStock, totalAvailable, quantity)=>{
    if (needManageStock && quantity !== undefined && quantity >= totalAvailable) return false;
    return true;
};
const convertDiscoveryPrice = function(price) {
    let promotions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (!price || !price.price || !price.sellPrice) return null;
    return {
        price: price.price,
        discountPercent: price.discount ? "-".concat(price.discount, "%") : undefined,
        displayRowTotal: (0,Currency_es/* formatCurrency */.xG)(price.price, {
            underline: true
        }),
        strikeThroughDisplayRowTotal: (0,Currency_es/* formatCurrency */.xG)(price.supplierRetailPrice || price.sellPrice, {
            underline: true
        }),
        promotions: promotions
    };
};

;// CONCATENATED MODULE: ./contexts/ProductDetailContext.tsx
function ProductDetailContext_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductDetailContext_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductDetailContext_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductDetailContext_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ProductDetailContext_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ProductDetailContext_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const initialState = {
    onSelectVariant: ()=>{},
    promotionBlocks: [],
    relatedProducts: [],
    showPopupCheckAge: false,
    setShowPopupCheckAge: ()=>{},
    selectPromotionLoading: false,
    showWarningPromotionWithInstallment: false,
    setShowWarningPromotionWithInstallment: ()=>{},
    selectedPromotionsNotApplyWithInstallment: [],
    productRatingData: {
        reviews: [],
        hasMore: false,
        setFilterParams: ()=>{},
        loadMore: ()=>{},
        noFilter: false,
        numberOfReviewsRemaining: 0,
        setPage: ()=>{},
        isValidating: false,
        refreshReviewList: ()=>{}
    },
    loadingProductDetailPage: false,
    setLoadingProductDetailPage: ()=>{}
};
const ProductDetailStateContext = /*#__PURE__*/ react.createContext(initialState);
const ProductDetailProvider = (param)=>{
    let { children , serverProduct , inlineBanners  } = param;
    const detailPage = useDetailPage(serverProduct);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailStateContext.Provider, {
            value: ProductDetailContext_objectSpreadProps(ProductDetailContext_objectSpread({}, detailPage), {
                inlineBanners
            }),
            children: children
        })
    });
};
function useProductDetailState() {
    const context = (0,react.useContext)(ProductDetailStateContext);
    if (!context) {
        throw new Error("useProductDetailState must be inside a ProductDetailStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 667913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ sendOTPToEmail; },
/* harmony export */   "Jz": function() { return /* binding */ createStudentInfo; },
/* harmony export */   "aP": function() { return /* binding */ getCustomerProfile; },
/* harmony export */   "mk": function() { return /* binding */ getProductReviews; },
/* harmony export */   "nE": function() { return /* binding */ createProductReview; },
/* harmony export */   "qD": function() { return /* binding */ verifyOTP; }
/* harmony export */ });
/* harmony import */ var _teko_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(847143);
/* harmony import */ var _clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44844);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


const getProductReviews = async (productId, params)=>{
    const { data  } = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.get */ .hS.get("api/v1/products/".concat(productId, "/reviews"), {
        params: _objectSpread({}, params)
    });
    return data.data;
};
const createProductReview = async (productId, payload)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .EK);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.post */ .hS.post("api/v1/products/".concat(productId, "/reviews"), payload);
    return res.data;
};
const getCustomerProfile = async (params)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .EK);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.get */ .hS.get("api/v1/profiles", {
        params: _objectSpread({}, params)
    });
    return res.data;
};
const createStudentInfo = async (profileId, payload, language)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .EK);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.post */ .hS.post("api/v1/profiles/".concat(profileId, "/student-info"), payload, {
        headers: {
            "Accept-Language": language || "*"
        }
    });
    return res.data;
};
const sendOTPToEmail = async (payload)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .EK);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.post */ .hS.post("api/v1/profiles/otp/send-email", payload);
    return res.data;
};
const verifyOTP = async (payload)=>{
    _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.addInterceptor */ .hS.addInterceptor(_teko_auth__WEBPACK_IMPORTED_MODULE_1__/* .accessTokenInterceptor */ .EK);
    const res = await _clients__WEBPACK_IMPORTED_MODULE_0__/* .consumerBffApi.post */ .hS.post("api/v1/profiles/otp/verify-email", payload);
    return res.data;
};


/***/ }),

/***/ 710957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jg": function() { return /* binding */ PaymentBankCode; },
/* harmony export */   "K$": function() { return /* binding */ PaymentMethodCode; },
/* harmony export */   "Lt": function() { return /* binding */ PaymentMethodType; },
/* harmony export */   "Vc": function() { return /* binding */ PaymentCardType; },
/* harmony export */   "Wk": function() { return /* binding */ BankType; },
/* harmony export */   "fH": function() { return /* binding */ PaymentBffCardType; },
/* harmony export */   "kJ": function() { return /* binding */ PaymentMethodGroupCode; }
/* harmony export */ });
var PaymentMethodCode = /* @__PURE__ */ ((PaymentMethodCode2) => {
  PaymentMethodCode2["COD"] = "COD";
  PaymentMethodCode2["COD_OFFLINE"] = "COD_OFFLINE";
  PaymentMethodCode2["VNPAYQR"] = "VNPAYQR";
  PaymentMethodCode2["VNPAY_GATEWAY"] = "VNPAY_GATEWAY";
  PaymentMethodCode2["VNPAY_QRCODE"] = "VNPAY_QRCODE";
  PaymentMethodCode2["CTT"] = "CTT";
  PaymentMethodCode2["MOBILE_BANKING"] = "MOBILE_BANKING";
  PaymentMethodCode2["LOYALTY"] = "LOYALTY";
  PaymentMethodCode2["EVOUCHER"] = "Phi\u1EBFu mua h\xE0ng";
  PaymentMethodCode2["CASH"] = "CASH";
  PaymentMethodCode2["VNPAY_TOKEN"] = "VNPAY_TOKEN";
  PaymentMethodCode2["ALEPAY_INSTALLMENT_CREDIT"] = "ALEPAY_INSTALLMENT_CREDIT";
  PaymentMethodCode2["VNPAY_INSTALLMENT_CREDIT"] = "VNPAY_INSTALLMENT_CREDIT";
  PaymentMethodCode2["PAYBILL"] = "PAYBILL";
  PaymentMethodCode2["VNPAY_GATEWAY_QR"] = "VNPAY_GATEWAY_QR";
  PaymentMethodCode2["VNPAY_GATEWAY_MOBILE_BANKING"] = "VNPAY_GATEWAY_MOBILE_BANKING";
  PaymentMethodCode2["VNPAY_GATEWAY_ATM"] = "VNPAY_GATEWAY_ATM";
  PaymentMethodCode2["VNPAY_GATEWAY_INTERNATIONAL_CARD"] = "VNPAY_GATEWAY_INTERNATIONAL_CARD";
  PaymentMethodCode2["ZALOPAY_GATEWAY"] = "ZALOPAY_GATEWAY";
  PaymentMethodCode2["MOMO_AIO"] = "MOMO_AIO";
  PaymentMethodCode2["SHOPEEPAY_GATEWAY"] = "SHOPEEPAY_GATEWAY";
  return PaymentMethodCode2;
})(PaymentMethodCode || {});
var PaymentBankCode = /* @__PURE__ */ ((PaymentBankCode2) => {
  PaymentBankCode2["VNPAYQR"] = "VNPAYQR";
  return PaymentBankCode2;
})(PaymentBankCode || {});
var PaymentMethodGroupCode = /* @__PURE__ */ ((PaymentMethodGroupCode2) => {
  PaymentMethodGroupCode2["CREDIT"] = "CREDIT";
  PaymentMethodGroupCode2["INSTALLMENT"] = "INSTALLMENT";
  PaymentMethodGroupCode2["CARD"] = "CARD";
  PaymentMethodGroupCode2["OFFLINE"] = "OFFLINE";
  PaymentMethodGroupCode2["LOYALTY"] = "LOYALTY";
  PaymentMethodGroupCode2["QR"] = "QR";
  return PaymentMethodGroupCode2;
})(PaymentMethodGroupCode || {});
var PaymentCardType = /* @__PURE__ */ ((PaymentCardType2) => {
  PaymentCardType2[PaymentCardType2["REDIRECT_URL_THANH_TOAN"] = 1] = "REDIRECT_URL_THANH_TOAN";
  PaymentCardType2[PaymentCardType2["GEN_QR_CONG"] = 2] = "GEN_QR_CONG";
  return PaymentCardType2;
})(PaymentCardType || {});
var PaymentBffCardType = /* @__PURE__ */ ((PaymentBffCardType2) => {
  PaymentBffCardType2["URL_REDIRECT"] = "URL_REDIRECT";
  PaymentBffCardType2["QR_CONTENT"] = "QR_CONTENT";
  PaymentBffCardType2["URL_DEEPLINK"] = "URL_DEEPLINK";
  return PaymentBffCardType2;
})(PaymentBffCardType || {});
var BankType = /* @__PURE__ */ ((BankType2) => {
  BankType2["BANK"] = "bank";
  BankType2["WALLET"] = "wallet";
  BankType2["INTERNATIONAL_CARD"] = "international_card";
  return BankType2;
})(BankType || {});
var PaymentMethodType = /* @__PURE__ */ ((PaymentMethodType2) => {
  PaymentMethodType2["MOBILE_BANKING"] = "MOBILE_BANKING";
  PaymentMethodType2["ATM"] = "ATM";
  PaymentMethodType2["VISA"] = "VISA";
  return PaymentMethodType2;
})(PaymentMethodType || {});




/***/ })

}]);